/* eslint-disable react/no-danger */
import classnames from "classnames";
import parse from "html-react-parser";
import React from "react";
import styles from "./info-banner.module.scss";

function InfoBanner({ href, text, topMargin = false }) {
  const parsedHTML = parse(text);

  return (
    <div
      className={classnames(
        styles["skinny-banner__wrapper"],
        topMargin ? styles["skinny-banner__wrapper--top-margin"] : "",
        href ? styles["skinny-banner__wrapper--link"] : "",
      )}
    >
      <div className={styles["skinny-banner"]}>
        {href ? (
          <a className={styles["skinny-banner__link"]} href={href}>
            <p className={styles["skinny-banner__message_long"]}>{parsedHTML}</p>
          </a>
        ) : (
          <p className={styles["skinny-banner__message_long"]}>{parsedHTML}</p>
        )}
      </div>
    </div>
  );
}

export default InfoBanner;
